<template lang="pug">
    v-form.pr-3
      v-layout(v-if='Datos.warehouse && Datos.warehouse[0] || modelo == "Inputs"')
        v-flex.xs12
          v-autocomplete( v-model="itemToAdd" @change='addItemToDocument()' :item-text='item => (item.existence && Datos.warehouse && Datos.warehouse[0] && item.existence[Object.keys(item.existence).filter( item => item.trim() == Datos.warehouse[0].name.trim() )] ) ? `${item.codigo} - ${item.descripcion} ${item.presentacion}` + "  (" + item.existence[Object.keys(item.existence).filter( item => item.trim() == Datos.warehouse[0].name.trim() )]   + ")" : `${item.codigo} - ${item.descripcion} ${item.presentacion}`' label='Buscar productos' :items="productsRecord" return-object)
      v-divider

      v-data-table( :headers="computedHeaders" :items="Datos.items"  )
        template( v-slot:item.numeracion='{item}' )
          span {{ Datos.items.indexOf(item) + 1 }}
        template( v-slot:item.descripcion='{item}')
          span {{ item.codigo }} {{ item.descripcion }}
        template( v-slot:item.cantidad='props')
          v-text-field( type='number' required v-model.number='props.item.cantidad' )
        template( v-slot:item.valor_unitario='props')
          v-text-field( type='number' required v-model.number='props.item.valor_unitario')
        template( v-slot:item.tipo_de_igv='props')
          v-btn(v-model='props.item.tipo_de_igv' outlined color='primary' @click='props.item.tipo_de_igv = props.item.tipo_de_igv === 1 ? 8 : 1')
            span {{ props.item.igv | number }} 
            v-icon(small v-if='props.item.tipo_de_igv === 8') fas fa-plus
        template( v-slot:item.descuento='props')
          v-text-field( type='number' required v-model.number='props.item.descuento' )
        template( v-slot:item.action='props')  
          v-btn( icon color='primary' @click='removeItemFromDocument(props.item)')
            v-icon(small) far fa-trash-alt

          span( :v-html='props.item.igv = toNumber((props.item.tipo_de_igv === 1) ? props.item.valor_unitario * 0.18 * props.item.cantidad : 0)'  )
          span( :v-html='props.item.precio_unitario = toNumber((props.item.tipo_de_igv === 1) ? props.item.valor_unitario * 1.18 : props.item.valor_unitario)' )
          span( :v-html='props.item.subtotal = toNumber(props.item.cantidad * props.item.valor_unitario - props.item.descuento) ' v-show='false' )
          span( :v-html='props.item.total = toNumber((props.item.tipo_de_igv === 1) ? ( props.item.cantidad * props.item.valor_unitario - props.item.descuento ) * 1.18 : props.item.cantidad * props.item.valor_unitario - props.item.descuento) ' v-show='false' )

</template>
<script>
import {mapState, mapGetters} from 'vuex'
export default {
  data: ()=>({
     selectedItemsHeaders: [
      { text: 'Nº', value: 'numeracion', sortable: false, oculto_en: [] },
      { text: 'Descripción',  value: 'descripcion', oculto_en: [] },
      { text: 'U. M.', value: 'unidad_de_medida', oculto_en: []},
      { text: 'Cantidad', value: 'cantidad', oculto_en: [] },
      { text: 'Valor U.', value: 'valor_unitario', oculto_en: ['Outputs'] },
      { text: 'IGV', value: 'tipo_de_igv', oculto_en: ['Outputs']},
      { text: 'Descuento (S/)', value: 'descuento', oculto_en: ['Outputs']},
      { text: 'SubTotal', value: 'subtotal', oculto_en: ['Outputs']},
      { text: 'Total', value: 'total', oculto_en: ['Outputs']},
      { text: '', value: 'action', oculto_en: []}
    ],
    itemToAdd: {
      codigo: '',
      descripcion: '',
      presentacion: '',
    },

  }),
  props: {
    modelo: String
  },

  methods: {
        
    removeItemFromDocument(item){
      let index = this.Datos.items.indexOf(item)
      this.Datos.items.splice(index, 1)
    },
    addItemToDocument(){
      this.Datos.items.push({
        ...this.itemToAdd, 
        descripcion: `${this.itemToAdd.descripcion} ${this.itemToAdd.presentacion}`,
        cantidad: 0, 
        valor_unitario: 0, 
        tipo_de_igv: 1, 
        anticipo_regularizacion: false,
        anticipo_documento_serie: "",
        anticipo_documento_numero: "",
        descuento: 0, 
        impuesto_bolsas: 0,
        precio_unitario: 0,
        subtotal: 0,
        igv: 0,
        total: 0,
      })
      
      this.itemToAdd = {
        codigo: '',
        descripcion: '',
        presentacion: '',
      }
    },
  },
  computed:{
    computedHeaders(){
      return this.selectedItemsHeaders.filter(item => item ) //item.oculto_en.indexOf(this.modelo) === -1
    },
    ...mapGetters({
      productsRecord: 'Product/record',
    }),
    Datos() { return this.$store.state[this.modelo].data },
  }
}
</script>
